var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal__Response",class:{ 'is-Active': _vm.updated === true }},[_c('lottie',{staticClass:"modal__ResponseAnimation",attrs:{"options":_vm.defaultOptions},on:{"animCreated":_vm.handleAnimation}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }